export default __webpack_public_path__ + "static/media/product-image-10.6411cd8e.png";